import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    UserProps,
    LoadUserById,
    setUserEdit,
    setUserReloadEdit,
    initUser,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    userId = null,
}: UserProps) => {
    const user = useSelector((state: StoreType) => state.user.userEdit)
    const reloadEdit = useSelector((state: StoreType) => state.user.reloadEdit)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setUserReloadEdit(false))
        setTimeout(() => {
            dispatch(setUserReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (userId === 0) {
            dispatch(setUserEdit(initUser))
            reload()
        } else {
            setLoadState(PENDING)
            LoadUserById(userId).then((res) => {
                dispatch(setUserEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!user) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {user.id ? `${lang.editUser} # ${user.id}` : lang.addUser}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form user={user} />
                }
                {
                    reloadEdit
                    && <Form user={user} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
